import React, { useEffect, useState } from 'react';
import '../../styles/Admin/accountForms.css';
import { useNavigate } from 'react-router-dom';
import { GrUserAdmin } from 'react-icons/gr';
import { BASE_URL } from '../../settings';

export default function AdminLogin({ setScreen }) {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [message, setMessage] = useState('');
    const [showLoading, setShowLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        // 👇️ apply a class to main top nav bar to hide it
        let mainNavBar = document.querySelector('._3drDv.MainNavBar');
        if (mainNavBar) mainNavBar.style.display = 'none';
    }, []);

    // 👇️ handler for login in admin.
    const login = () => {
        setError(null);
        setMessage(null);
        setShowLoading(true);

        if (email && email?.length > 0 && isNaN(email) && email?.trim()) {
            if (password && password?.length > 0 && isNaN() && password?.trim()) {
                fetch(`${BASE_URL}/admin/login`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ email, password }),
                })
                    .then(async (result) => {
                        setShowLoading(false);
                        setError(null);
                        let response = await result?.json();
                        if (response?.msg === null) {
                            setError(response?.errorMsg);
                        } else {
                            console.log(response);
                            setMessage(response?.msg);
                            setScreen('Main Page');
                            window.location.reload();
                            // navigate('/');
                        }
                    })
                    .catch((error) => {
                        if (error?.message == 'Failed to fetch') {
                            setError('Could not reach the servers');
                        } else {
                            setError('Some error occurred!');

                            console.log('the error:', error);
                        }
                        setShowLoading(false);
                        setMessage(null);
                    });
            } else {
                setShowLoading(false);
                setError('Provide password!');
                setMessage(null);
            }
        } else {
            setShowLoading(false);
            setError('Provide email!');
            setMessage(null);
        }
    };

    return (
        <div className='admin-login-container'>
            <div className='login-container'>
                <div className='form-header-container'>
                    <GrUserAdmin size={30} />
                    <h1 className='form-header'>Admin Login</h1>
                </div>

                {error && <span className='error'>{error}</span>}
                {message && <span className='message'>{message}</span>}

                <div className='form-inputs'>
                    <input
                        type='email'
                        name='email'
                        placeholder='Email'
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <input
                        type='password'
                        name='password'
                        placeholder='Password'
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />
                </div>

                <button
                    className='action-btn'
                    onClick={login}
                    disabled={showLoading || email?.length <= 0 || password?.length <= 0}
                    style={{
                        backgroundColor: showLoading || !email || !password ? '#aaa' : 'darkblue',
                        color: showLoading || !email || !password ? '#333' : '#eee',
                    }}
                >
                    Login
                </button>

                <span className='link' onClick={() => setScreen('Signup')}>
                    Not a user? Signup
                </span>

                {/* <span className='link' onClick={() => setScreen('reset-password')}>
                    Forgot password?
                </span> */}
            </div>
        </div>
    );
}
